import { API_URL } from '../../../app-config/constants';
import { DownloadableFile } from '../../../types/DownloadableFile';
import { ExportFormat } from '../../../types/ExportFormat';
import { post } from '../request';

export function triggerExport(format: ExportFormat, from?: string, until?: string): Promise<DownloadableFile> {
    return post(`${API_URL}/anytime-feedback-export`, {
        getData: {
            format,
            from,
            until,
        },
    });
}

export function triggerTeamExport(format: ExportFormat, from?: string, until?: string): Promise<DownloadableFile> {
    return post(`${API_URL}/anytime-feedback-export/team`, {
        getData: {
            format,
            from,
            until,
        },
    });
}
